import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base/base.service';
import { SessionUserHashManagerService } from './session-user-hash-manager/session-user-hash-manager.service';
import { HttpClient } from '@angular/common/http';
import { ClientUserSearchFilters } from '../_models/admin/client-user-search-filters.model';
import { backgroundContext } from '../_helpers/loading.interceptor';

@Injectable()
export class ClientService extends BaseService {
  
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    protected hashManagerService: SessionUserHashManagerService
    ) {
    super(hashManagerService);
    this.apiUrl += this.apiUrl.endsWith("/") ? "" : "/";
   }

  /**
   * `filters` carries the filters.client-users parameters (companyIds, roleCode, active, authMethod,
   * neverSignedIn). The screen passes it only when that switch is on; without it the body is the plain
   * { searchPhrase, userId } the screen always sent.
   */
  clientUserSearch(searchPhrase: string, userId: number, filters?: ClientUserSearchFilters) {
    const request = { "searchPhrase": searchPhrase, "userId": userId, ...(filters ?? {}) };
    return this.http.post(this.apiUrl + 'api/Clients/ClientUserSearch/'
    , request
    , this.prepareOptions(request)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('clientUserSearch'))
    );
  }

  UpdateClientUsers(data) {
    return this.http.post(this.apiUrl + 'api/Clients/UpdateClientUsers', data, this.prepareOptions(data)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('UpdateClientUsers'))
    );
  }

  CreateClientUsers(data) {
    return this.http.post(this.apiUrl + 'api/Clients/CreateClientUsers', data, this.prepareOptions(data)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('CreateClientUsers'))
    );
  }

  GetClients(userId) {
    return this.http.get(this.apiUrl + 'api/Clients/GetClients?userId=' + userId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetClients'))
    );
  }

  GetClientsForClassroomOverview(userId) {
    return this.http.get(this.apiUrl + 'api/Clients/GetClientsForClassroomOverview?userId=' + userId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetClients'))
    );
  }

  GetReportClients(userId) {
    return this.http.get(this.apiUrl + 'api/Clients/GetClientsForReports?userId=' + userId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetReportClients'))
    );
  }

  SendEmailsToClientUsers(data) {
    return this.http.post(this.apiUrl + 'api/Clients/SendEmailsToClientUsers', data, this.prepareOptions(data)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('SendEmailsToClientUsers'))
    );
  }

  GetClientUser(appUserId) {
    return this.http.get(this.apiUrl + 'api/Clients/GetClientUser?appUserId=' + appUserId, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('GetClientUser'))
    );
  }

  /**
   * A client's users, for booking setup's custodian picker. With placementId, only the people who can see that booking
   * (set to Every booking at its client, or named on it) while clientusers.booking-grants is on.
   */
  getClientUserDetailsByClientId(clientId: number, placementId?: number | string) {
    const query = placementId ? '?placementId=' + encodeURIComponent(String(placementId)) : '';
    return this.http.get(this.apiUrl + 'api/Clients/GetClientUserDetailsByClient/' + clientId + query, this.prepareOptions(null)).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getClientUserDetailsByClientId'))
    );
  }

  /** `background` (the client suggestions) fetches without showing the spinner. */
  getClientListForAddStudent(background = false) {
    const options = background ? { ...this.prepareOptions(null), context: backgroundContext() } : this.prepareOptions(null);
    return this.http.get(this.apiUrl + 'api/Clients/GetClientListForAddStudent/', options).pipe(
      map((data: any) => {
        
        return data.body;
      }), catchError(this.handleError('getClientListForAddStudent'))
    );
  }

}
